<template>
    <section class="payView">
		<van-nav-bar title="充值" left-arrow @click-left="skipFull" class="top_bar" />	
		<section v-if="!isLoading">
			<section class="recharge_success" v-if="status == 2">
				<img src="../../../assets/img/recharge_success.png" />
				<p>充值成功</p>
				<van-button round type="danger" class="danger-button" @click="skipOrder">立即抢单</van-button>
			</section>
			<section class="recharge_fail" v-else-if="status == 3">
				<img src="../../../assets/img/recharge_fail.png" />
				<p>充值失败</p>
				<van-button round type="danger" class="danger-button" @click="skipKefu">联系客服</van-button>
			</section>
			<section class="recharge_loading" v-else-if="status == 4">
				<img src="../../../assets/img/recharge_loading.png" />
				<p>正在查询充值结果，请稍后…</p>
			</section>
		</section>
		<van-loading size="24px" vertical v-else>加载中...</van-loading>
    </section>
</template>
<script>
import buyServer from "api/buy";
import Nav from "components/Nav"
export default {
    name: "payView",
	components: {
		Nav,
	},
    data() {
        return {
            status: 1,
			payParams: {
                orderId: "",
                cashierTypeId: "",
                amount: "",
                description: "充值",
                remark: "",
                returnUrl: "",
            },
			payId: '',
			isLoading: true,
        };
    },
	// 支付宝1
	// 微信
	// 内购 2
    created() {
		this.status = localStorage.getItem("status")||1
        this.payParams.orderId = this.$route.params.id;
        this.payParams.amount = this.$route.params.amount;
        this.payParams.cashierTypeId = this.$route.params.type;
        this.productid = this.$route.params.pid||0;
        this.sid = this.$route.params.sid;
		this.payParams.returnUrl = ``;
		if(this.status==1) {
			this.isLoading = true  
			this.plusReady()
		}
	},

	beforeDestroy() {
	},
	mounted() {
		if(this.$store.state.clientType==2) {
			document.addEventListener('plusready', function() { 
				var webview = plus.webview.currentWebview(); 
				plus.key.addEventListener('backbutton', function() {
					webview.canBack(function(e) {
						if(e.canBack) {
							webview.back()
						}else {
							webview.close();
						}
					})
				})
			}) 
		}
	},
    methods: {
		showPageView() {
            buyServer.SearchPayView(this.payParams).then((res) => {
				localStorage.setItem("status", 4)
				localStorage.setItem("pay", res.data.id)
				this.payFn(res.data.payParams)
				// setTimeout(() => {
				// 	this.status = 4
				// }, 1000)
            });
        },
		plusReady() {
            // 获取支付通道
            plus.payment.getChannels((channels)=> {
					for (var i in channels) {  
						var channel = channels[i];  
						// {"id":"alipay","description":"支付宝","serviceReady":true}
						if (channel.id === 'alipay') {  
							this.channel = channel;  
							this.showPageView()
						}  
					}
                },
                (e)=> {
                    alert("获取支付通道失败：" + e.message);
                }
            );
        },
		payFn(PAYSERVER) {
			plus.payment.request(this.channel,PAYSERVER, result=>{  
				this.isLoading = false
				this.status =2
			},error=>{  
				this.isLoading = false
				this.status =3
			});  
        },
		skipOrder() {
			this.$router.push({name: 'index'})
		},
		skipKefu() {
			this.$router.push({name: 'kefu'})
		},
		skipFull() {
			this.$router.push({name: 'full'})
		},

    },
};
</script>

<style lang="scss">
.payView {
    .recharge_success,
    .recharge_fail {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        width: 100%;
        img {
            width: 104px;
        }
        p {
            color: #2b2f3a;
            font-size: 20px;
            font-weight: bold;
            padding-top: 15px;
        }
        .van-button--danger {
            margin-top: 68px;
            width: 217px;
            height: 46px;
            font-size: 17px;
            font-weight: bold;
            .van-button__text {
                color: #fff;
                padding-top: 0;
            }
        }
    }
	.wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}

	.block {
		width: 120px;
		height: 120px;
		background-color: #fff;
	}
	.van-loading {
		position: fixed;
		top: 30%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
    .recharge_loading {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        width: 100%;
        img {
            width: 120px;
        }
        p {
            color: #575e72;
            font-size: 16px;
            padding-top: 36px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/user/alipay/Alipay.vue